import { AfterViewInit, Component, ElementRef, HostListener, Input, NgZone, OnInit, ViewChild } from "@angular/core";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import { ModuleManager } from "src/shared/models/module-manager";
import { ModuleManagerRefreshType } from "src/shared/models/module-manager/module-manager-options.model";
import { NavigationService } from 'src/app/navigation/navigation.service';
import { SupervisorService } from "./supervisor.service";
import { SupervisorObject } from "./supervisor.model";
import OverlayScrollbars from 'overlayscrollbars';


@Component({
    selector: 'cxone-games-tracker',
    templateUrl: './cxone-games-tracker.component.html',
    styleUrl: './cxone-games-tracker.component.scss'
})

export class CxoneGamesTrackerComponent implements OnInit {
    @Input() moduleManager: ModuleManager;
    @Input() moduleKey: string;
    @ViewChild("gameContainer") gameContainer: ElementRef;

    public noData = false;
    public isDataLoading = false;
    /** Error state trigger */
    public noPMLicense = false;
    public somethingWentWrong = false;
    private loginId = 0;
    public supervisors: SupervisorObject[];
    currentView: number;

    scrollOptions: OverlayScrollbars.PartialOptions = {
        scrollbars: {
            autoHide: "leave",
            autoHideDelay: 100,
            theme: "scrollbar-games"
        }
    };

    hiddenScrollOptions: OverlayScrollbars.PartialOptions = {
        scrollbars: {
            autoHide: "leave",
            visibility: "hidden",
            autoHideDelay: 100,
            theme: "scrollbar-challenge",
        },
    };

    constructor(
        private cvLocalizationService: CVLocalizationService,
        private zone: NgZone,
        private navigationService: NavigationService,
        private supervisorService: SupervisorService
    ) { }

    async ngOnInit() {
        this.moduleManager.showLoader = true;

        this.moduleManager.setOptions({
            onSettingsApplied: settings => {
                this.loadData(false);
            },
            hasRefresh: true,
            refreshType: ModuleManagerRefreshType.FiveMinute,
            onRefresh: (isAutoRefresh) =>
                this.zone.run(() => this.loadData(isAutoRefresh)),
            canRefresh: () => true,
        });

        await this.loadLocalization();
        this.noPMLicense = !this.navigationService.hasPartnerPMAccess;
        this.supervisorService.setModuleManager(this.moduleManager);
    }

    ngAfterViewChecked() {
        this.supervisorService.setSeeMoreContainer(this.gameContainer);
        this.supervisorService.getCurrentView().subscribe(view => {
            this.currentView = view;
        });
    }

    async loadLocalization() {
        await this.cvLocalizationService.GetSection('Games_Module');
    }

    public async loadData(isAutoRefresh: boolean) {
        if (!this.noPMLicense) {
            if (this.isDataLoading)
                return; // don't have multiple outgoing requests

            this.isDataLoading = true;
            this.moduleManager.showLoader = true;
            this.somethingWentWrong = false;

            try {
                let response = await this.supervisorService.getSupervisorsData(this.moduleKey, this.loginId);
                this.supervisors = response?.data;
            } catch (err) {
                this.moduleManager.handleLoadError(err, isAutoRefresh);
                this.somethingWentWrong = true;
                return;
            }
            finally {
                this.moduleManager.showLoader = false;
                this.noData = this.supervisors === undefined || this.supervisors === null || this.supervisors.length === 0;
                this.moduleManager.setAutoRefreshReady();
                this.isDataLoading = false;
            }
        }
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText("Games_Module", key, defaultValue);
        return baseString;
    }
}
